// extracted by mini-css-extract-plugin
export default {"title":"template-list-module__title--W0uLr","metadata":"template-list-module__metadata--R_oOs","Box":"template-list-module__Box--CKI4h","Box_1":"template-list-module__Box_1--H8Rvl"};